import { useState } from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';
import {
  Button,
  Card,
  CardBody,
  Container
} from 'reactstrap';
import BetterBreadcrumb from 'src/components/Common/BetterBreadCrumb';
import { actionColumnStyles, dataTableCustomStyles } from 'src/components/Common/FixedActionColumn';
import { useAppSelector } from 'src/rtk/app/hook';
import { useGetScheduleListForItmcQuery } from 'src/rtk/features/logbookMonitoringReport/logbookMonitoringReportApi';
import loader from '../../assets/images/loader.gif';
import ITMCApprovalViewModal from './ITMCApprovalViewModal';
import { InterviewReportPDF } from './InterviewReportPDF';


const ScheduleListForITMC = () => {

  const authUser = useAppSelector((state) => state.auth.user);
  const [approvalViewModal, setApprovalViewModal] = useState(false);
  const [rowData, setRowData] = useState<any>(null);
  const [reportId, setReportId] = useState<string>('');

  const [page, setPage] = useState<any>(1);
  const [limit, setLimit] = useState<any>(10);
  const [search, setSearch] = useState('');

  const generateQueryUrl = () => {
    return `page=${page}&paginate_per_page=${limit}${search}`;
  };

  const handlePageChange = (page: number) => {
    setPage(page);
  };

  const handlePerRowsChange = (newPerPage: number, page: number) => {
    setLimit(newPerPage);
    setPage(page);
  };

  const { data: scheduleListData, isLoading } = useGetScheduleListForItmcQuery(generateQueryUrl());


  const columns: TableColumn<any>[] = [
    {
      name: <div>Sl. No.</div>,
      width: '80px',
      cell: (row, index) => <strong>{index + 1}</strong>,
    },

    {
      name: <div>Trainee Name</div>,
      selector: (row) => row?.registration?.personal_info?.full_name,
      wrap: true,
    },

    {
      name: <div>BMDC Number</div>,
      selector: (row) => row?.registration?.bmdc_registration_no,
      wrap: true,
    },

    {
      name: <div>Session & Year</div>,
      selector: (row) => `${row?.registration?.current_session_and_supervisor_info?.session_name} - ${row?.registration?.current_session_and_supervisor_info?.session_year}`,
      wrap: true,
    },
    {
      name: <div>Mark</div>,
      selector: (row) => row?.average_marking,
      wrap: true,
    },
    {
      name: <div>Result</div>,
      selector: (row) => row?.result,
      cell: (row) => {
        switch (row?.result) {
          case 'Pass':
            return (
              <>
                <div className="badge rounded-pill d-inline-block badge-approved font-size-12 fw-medium">
                  {row?.result}
                </div>
              </>
            );

          case 'Fail':
            return (
              <>
                <div className="badge rounded-pill d-inline-block badge-pending font-size-12 fw-medium">
                  {row?.result}
                </div>
              </>
            );

          default:
            return (
              <>
                <div className="badge rounded-pill d-inline-block badge-pending font-size-12 fw-medium">
                  {'Not Evaluated'}
                </div>
              </>
            );
        }
      },
      wrap: true,
    },
    {
      name: <div>ITMC Approval Status</div>,
      selector: (row) => row?.itmc_approval_status,
      cell: (row) => {
        switch (row?.itmc_approval_status) {
          case 'Approved':
            return (
              <>
                <div className="badge rounded-pill d-inline-block badge-approved font-size-12 fw-medium">
                  {row?.itmc_approval_status}
                </div>
              </>
            );

          case 'Pending':
            return (
              <>
                <div className="badge rounded-pill d-inline-block badge-pending font-size-12 fw-medium">
                  {row?.itmc_approval_status}
                </div>
              </>
            );

          default:
            return (
              <>
                <div className="badge rounded-pill d-inline-block badge-pending font-size-12 fw-medium">
                  {'N/A'}
                </div>
              </>
            );
        }
      },
      wrap: true,
    },

    {
      name: <div>Action</div>,
      style: actionColumnStyles,
      width: '230px',
      cell: (row, index) => (
        <div className='d-flex gap-1 my-1'>
          <Button
            color="info"
            size="sm"
            onClick={() => {
              setApprovalViewModal(true);
              setRowData(row);
            }}
          >
            Approval
          </Button>
          {
            row?.itmc_approval_status === 'Approved' && (
              <Button
                color="success"
                size="sm"
                onClick={() => {
                  setReportId(row?.id);
                }}
              >
                <i className="fa-solid fa-print" /> View Report
              </Button>
            )
          }
          {
            reportId === row?.id && (
              <InterviewReportPDF traineeData={row} setReportId={setReportId} />
            )
          }

          {(approvalViewModal && rowData?.id === row.id) && (
            <ITMCApprovalViewModal
              isOpen={approvalViewModal}
              toggle={() => setApprovalViewModal(!approvalViewModal)}
              traineeData={rowData}
            />
          )}
        </div>
      ),
    },
  ];

  return (
    <div className="page-content">
      {isLoading ? (
        <div className="overlay">
          <img src={loader} alt="Loading" height={100} width={300} />
        </div>
      ) : null}
      <Container fluid>
        <BetterBreadcrumb
          breadcrumbItem={[{ link: '/interview-schedule-create', name: 'Schedule Create' }]}
          title={'Trainee List'}
        />

        <Card>
          <CardBody>
            <DataTable
              columns={columns}
              data={scheduleListData?.data?.data || []}
              customStyles={dataTableCustomStyles}
              // pagination
              // paginationServer
              progressPending={isLoading}
              expandOnRowClicked
              highlightOnHover
              // onChangePage={handlePageChange}
              // onChangeRowsPerPage={handlePerRowsChange}
              // paginationTotalRows={approvalList?.data?.total}
              // paginationRowsPerPageOptions={[2, 5, 10, 20, 50, 100, 200]}
              responsive
              persistTableHead={true}
            />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default ScheduleListForITMC;
